/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssignMember200,
  CreateDepartment200,
  CreateDepartmentRequest,
  CreateTeam200,
  CreateTeamRequest,
  DeactivateTeam200,
  DeleteDepartment200,
  DeleteTeam200,
  Department,
  GetDepartment200,
  GetTeam200,
  PagedResponseDepartment,
  ReactivateTeam200,
  RemoveMember200,
  SearchDepartmentsParams,
  Team,
  UpdateDepartment200,
  UpdateDepartmentRequest,
  UpdateTeam200,
  UpdateTeamRequest,
  UserResponse
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List departments for the caller's organisation
 */
export const listDepartments = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<Department[]>(
      {url: `/api/v1/departments`, method: 'GET', signal
    },
      );
    }
  



export const getListDepartmentsQueryKey = () => {
    return [
    `/api/v1/departments`
    ] as const;
    }

    
export const getListDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof listDepartments>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDepartmentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDepartments>>> = ({ signal }) => listDepartments(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listDepartments>>>
export type ListDepartmentsQueryError = unknown


export function useListDepartments<TData = Awaited<ReturnType<typeof listDepartments>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDepartments>>,
          TError,
          Awaited<ReturnType<typeof listDepartments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDepartments<TData = Awaited<ReturnType<typeof listDepartments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDepartments>>,
          TError,
          Awaited<ReturnType<typeof listDepartments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDepartments<TData = Awaited<ReturnType<typeof listDepartments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List departments for the caller's organisation
 */

export function useListDepartments<TData = Awaited<ReturnType<typeof listDepartments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDepartmentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a department
 */
export const createDepartment = (
    createDepartmentRequest: CreateDepartmentRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateDepartment200>(
      {url: `/api/v1/departments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDepartmentRequest, signal
    },
      );
    }
  


export const getCreateDepartmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: CreateDepartmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: CreateDepartmentRequest}, TContext> => {

const mutationKey = ['createDepartment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDepartment>>, {data: CreateDepartmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createDepartment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createDepartment>>>
    export type CreateDepartmentMutationBody = CreateDepartmentRequest
    export type CreateDepartmentMutationError = unknown

    /**
 * @summary Create a department
 */
export const useCreateDepartment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: CreateDepartmentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDepartment>>,
        TError,
        {data: CreateDepartmentRequest},
        TContext
      > => {

      const mutationOptions = getCreateDepartmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List teams under a department
 */
export const listTeams = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Team[]>(
      {url: `/api/v1/departments/${id}/teams`, method: 'GET', signal
    },
      );
    }
  



export const getListTeamsQueryKey = (id?: string,) => {
    return [
    `/api/v1/departments/${id}/teams`
    ] as const;
    }

    
export const getListTeamsQueryOptions = <TData = Awaited<ReturnType<typeof listTeams>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeams>>> = ({ signal }) => listTeams(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeams>>>
export type ListTeamsQueryError = unknown


export function useListTeams<TData = Awaited<ReturnType<typeof listTeams>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeams>>,
          TError,
          Awaited<ReturnType<typeof listTeams>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTeams<TData = Awaited<ReturnType<typeof listTeams>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeams>>,
          TError,
          Awaited<ReturnType<typeof listTeams>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTeams<TData = Awaited<ReturnType<typeof listTeams>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List teams under a department
 */

export function useListTeams<TData = Awaited<ReturnType<typeof listTeams>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTeamsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a team under a department
 */
export const createTeam = (
    id: string,
    createTeamRequest: CreateTeamRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateTeam200>(
      {url: `/api/v1/departments/${id}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTeamRequest, signal
    },
      );
    }
  


export const getCreateTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{id: string;data: CreateTeamRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{id: string;data: CreateTeamRequest}, TContext> => {

const mutationKey = ['createTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeam>>, {id: string;data: CreateTeamRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  createTeam(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createTeam>>>
    export type CreateTeamMutationBody = CreateTeamRequest
    export type CreateTeamMutationError = unknown

    /**
 * @summary Create a team under a department
 */
export const useCreateTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{id: string;data: CreateTeamRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTeam>>,
        TError,
        {id: string;data: CreateTeamRequest},
        TContext
      > => {

      const mutationOptions = getCreateTeamMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reactivate a previously deactivated team
 */
export const reactivateTeam = (
    id: string,
    teamId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ReactivateTeam200>(
      {url: `/api/v1/departments/${id}/teams/${teamId}/reactivate`, method: 'POST', signal
    },
      );
    }
  


export const getReactivateTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateTeam>>, TError,{id: string;teamId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reactivateTeam>>, TError,{id: string;teamId: string}, TContext> => {

const mutationKey = ['reactivateTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateTeam>>, {id: string;teamId: string}> = (props) => {
          const {id,teamId} = props ?? {};

          return  reactivateTeam(id,teamId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReactivateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateTeam>>>
    
    export type ReactivateTeamMutationError = unknown

    /**
 * @summary Reactivate a previously deactivated team
 */
export const useReactivateTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateTeam>>, TError,{id: string;teamId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivateTeam>>,
        TError,
        {id: string;teamId: string},
        TContext
      > => {

      const mutationOptions = getReactivateTeamMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Assign a user to a team
 */
export const assignMember = (
    id: string,
    teamId: string,
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AssignMember200>(
      {url: `/api/v1/departments/${id}/teams/${teamId}/members/${userId}`, method: 'POST', signal
    },
      );
    }
  


export const getAssignMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignMember>>, TError,{id: string;teamId: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignMember>>, TError,{id: string;teamId: string;userId: string}, TContext> => {

const mutationKey = ['assignMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignMember>>, {id: string;teamId: string;userId: string}> = (props) => {
          const {id,teamId,userId} = props ?? {};

          return  assignMember(id,teamId,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignMemberMutationResult = NonNullable<Awaited<ReturnType<typeof assignMember>>>
    
    export type AssignMemberMutationError = unknown

    /**
 * @summary Assign a user to a team
 */
export const useAssignMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignMember>>, TError,{id: string;teamId: string;userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignMember>>,
        TError,
        {id: string;teamId: string;userId: string},
        TContext
      > => {

      const mutationOptions = getAssignMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Remove a user from a team
 */
export const removeMember = (
    id: string,
    teamId: string,
    userId: string,
 ) => {
      
      
      return apiClient<RemoveMember200>(
      {url: `/api/v1/departments/${id}/teams/${teamId}/members/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,{id: string;teamId: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,{id: string;teamId: string;userId: string}, TContext> => {

const mutationKey = ['removeMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeMember>>, {id: string;teamId: string;userId: string}> = (props) => {
          const {id,teamId,userId} = props ?? {};

          return  removeMember(id,teamId,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeMember>>>
    
    export type RemoveMemberMutationError = unknown

    /**
 * @summary Remove a user from a team
 */
export const useRemoveMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,{id: string;teamId: string;userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeMember>>,
        TError,
        {id: string;teamId: string;userId: string},
        TContext
      > => {

      const mutationOptions = getRemoveMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deactivate (dissolve) a team — hides it from new work package assignments, keeps existing history
 */
export const deactivateTeam = (
    id: string,
    teamId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<DeactivateTeam200>(
      {url: `/api/v1/departments/${id}/teams/${teamId}/deactivate`, method: 'POST', signal
    },
      );
    }
  


export const getDeactivateTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTeam>>, TError,{id: string;teamId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateTeam>>, TError,{id: string;teamId: string}, TContext> => {

const mutationKey = ['deactivateTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateTeam>>, {id: string;teamId: string}> = (props) => {
          const {id,teamId} = props ?? {};

          return  deactivateTeam(id,teamId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateTeam>>>
    
    export type DeactivateTeamMutationError = unknown

    /**
 * @summary Deactivate (dissolve) a team — hides it from new work package assignments, keeps existing history
 */
export const useDeactivateTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTeam>>, TError,{id: string;teamId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateTeam>>,
        TError,
        {id: string;teamId: string},
        TContext
      > => {

      const mutationOptions = getDeactivateTeamMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single department
 */
export const getDepartment = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetDepartment200>(
      {url: `/api/v1/departments/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetDepartmentQueryKey = (id?: string,) => {
    return [
    `/api/v1/departments/${id}`
    ] as const;
    }

    
export const getGetDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getDepartment>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartment>>> = ({ signal }) => getDepartment(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartment>>>
export type GetDepartmentQueryError = unknown


export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartment>>,
          TError,
          Awaited<ReturnType<typeof getDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartment>>,
          TError,
          Awaited<ReturnType<typeof getDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single department
 */

export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a department — must have no teams
 */
export const deleteDepartment = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteDepartment200>(
      {url: `/api/v1/departments/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDepartmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDepartment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDepartment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDepartment(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDepartment>>>
    
    export type DeleteDepartmentMutationError = unknown

    /**
 * @summary Delete a department — must have no teams
 */
export const useDeleteDepartment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDepartment>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteDepartmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a department's name/colour
 */
export const updateDepartment = (
    id: string,
    updateDepartmentRequest: UpdateDepartmentRequest,
 ) => {
      
      
      return apiClient<UpdateDepartment200>(
      {url: `/api/v1/departments/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateDepartmentRequest
    },
      );
    }
  


export const getUpdateDepartmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: string;data: UpdateDepartmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: string;data: UpdateDepartmentRequest}, TContext> => {

const mutationKey = ['updateDepartment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDepartment>>, {id: string;data: UpdateDepartmentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDepartment(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateDepartment>>>
    export type UpdateDepartmentMutationBody = UpdateDepartmentRequest
    export type UpdateDepartmentMutationError = unknown

    /**
 * @summary Update a department's name/colour
 */
export const useUpdateDepartment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{id: string;data: UpdateDepartmentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDepartment>>,
        TError,
        {id: string;data: UpdateDepartmentRequest},
        TContext
      > => {

      const mutationOptions = getUpdateDepartmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single team
 */
export const getTeam = (
    id: string,
    teamId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetTeam200>(
      {url: `/api/v1/departments/${id}/teams/${teamId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetTeamQueryKey = (id?: string,
    teamId?: string,) => {
    return [
    `/api/v1/departments/${id}/teams/${teamId}`
    ] as const;
    }

    
export const getGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof getTeam>>, TError = unknown>(id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamQueryKey(id,teamId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeam>>> = ({ signal }) => getTeam(id,teamId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && teamId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getTeam>>>
export type GetTeamQueryError = unknown


export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = unknown>(
 id: string,
    teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = unknown>(
 id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = unknown>(
 id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single team
 */

export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = unknown>(
 id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamQueryOptions(id,teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a team — must have no members and no work package assignment history
 */
export const deleteTeam = (
    id: string,
    teamId: string,
 ) => {
      
      
      return apiClient<DeleteTeam200>(
      {url: `/api/v1/departments/${id}/teams/${teamId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{id: string;teamId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{id: string;teamId: string}, TContext> => {

const mutationKey = ['deleteTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeam>>, {id: string;teamId: string}> = (props) => {
          const {id,teamId} = props ?? {};

          return  deleteTeam(id,teamId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>
    
    export type DeleteTeamMutationError = unknown

    /**
 * @summary Delete a team — must have no members and no work package assignment history
 */
export const useDeleteTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{id: string;teamId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeam>>,
        TError,
        {id: string;teamId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTeamMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a team's name/colour
 */
export const updateTeam = (
    id: string,
    teamId: string,
    updateTeamRequest: UpdateTeamRequest,
 ) => {
      
      
      return apiClient<UpdateTeam200>(
      {url: `/api/v1/departments/${id}/teams/${teamId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamRequest
    },
      );
    }
  


export const getUpdateTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{id: string;teamId: string;data: UpdateTeamRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{id: string;teamId: string;data: UpdateTeamRequest}, TContext> => {

const mutationKey = ['updateTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeam>>, {id: string;teamId: string;data: UpdateTeamRequest}> = (props) => {
          const {id,teamId,data} = props ?? {};

          return  updateTeam(id,teamId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeam>>>
    export type UpdateTeamMutationBody = UpdateTeamRequest
    export type UpdateTeamMutationError = unknown

    /**
 * @summary Update a team's name/colour
 */
export const useUpdateTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{id: string;teamId: string;data: UpdateTeamRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTeam>>,
        TError,
        {id: string;teamId: string;data: UpdateTeamRequest},
        TContext
      > => {

      const mutationOptions = getUpdateTeamMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List a team's members
 */
export const listMembers = (
    id: string,
    teamId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<UserResponse[]>(
      {url: `/api/v1/departments/${id}/teams/${teamId}/members`, method: 'GET', signal
    },
      );
    }
  



export const getListMembersQueryKey = (id?: string,
    teamId?: string,) => {
    return [
    `/api/v1/departments/${id}/teams/${teamId}/members`
    ] as const;
    }

    
export const getListMembersQueryOptions = <TData = Awaited<ReturnType<typeof listMembers>>, TError = unknown>(id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembersQueryKey(id,teamId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({ signal }) => listMembers(id,teamId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && teamId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type ListMembersQueryError = unknown


export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = unknown>(
 id: string,
    teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = unknown>(
 id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = unknown>(
 id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a team's members
 */

export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = unknown>(
 id: string,
    teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMembersQueryOptions(id,teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable department list for the main Departments list page
 */
export const searchDepartments = (
    params?: SearchDepartmentsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseDepartment>(
      {url: `/api/v1/departments/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchDepartmentsQueryKey = (params?: SearchDepartmentsParams,) => {
    return [
    `/api/v1/departments/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof searchDepartments>>, TError = unknown>(params?: SearchDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchDepartmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchDepartments>>> = ({ signal }) => searchDepartments(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof searchDepartments>>>
export type SearchDepartmentsQueryError = unknown


export function useSearchDepartments<TData = Awaited<ReturnType<typeof searchDepartments>>, TError = unknown>(
 params: undefined |  SearchDepartmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDepartments>>,
          TError,
          Awaited<ReturnType<typeof searchDepartments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDepartments<TData = Awaited<ReturnType<typeof searchDepartments>>, TError = unknown>(
 params?: SearchDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDepartments>>,
          TError,
          Awaited<ReturnType<typeof searchDepartments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDepartments<TData = Awaited<ReturnType<typeof searchDepartments>>, TError = unknown>(
 params?: SearchDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable department list for the main Departments list page
 */

export function useSearchDepartments<TData = Awaited<ReturnType<typeof searchDepartments>>, TError = unknown>(
 params?: SearchDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchDepartmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




